export default {"src":"kbwebsite/assets/_next/static/media/mail.2c74197d.svg","height":24,"width":24};